
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Image, ScrollTracking } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  Das Zürcher Familienunternehmen Bindella folgt mit sieben Lokalen an zweiter
  Stelle: der Kornhauskeller, das Kornhauscafé, die Spaghetti Factory, das
  Lorenzini, das Du Théâtre und das Restaurant Verdi in der Gerechtigkeitsgasse.
    </p>
    <p>
  Angefangen hat alles mit dem Tessiner Jean Bindella, der 1909 eine
  Weinhandlung gründete und erster Chianti-Importeur der Schweiz war. Das
  Unternehmen wird mit Italianità verbunden, dabei hat der Gründer spanische
  Wurzeln. Den Weinhandel gibt es noch immer, aber bekannter sind die
  italienischen Restaurants. Schweizweit sind es 44, sieben davon in Bern.
  Bindellas sind in Zürich verwurzelt, weshalb es in Bern eine Weile dauerte,
  bis sich die Familienpizzeria Santa Lucia nach der Eröffnung im Jahr 2012
  etabliert hatte. Das A und O des Unternehmens seien die guten Standorte: Fünf
  der sieben Berner Lokale stehen rund um den Kornhausplatz. Das historische
  Kornhaus übernahmen sie im Oktober 1999. Der Keller wurde vergangenen Sommer
  renoviert.
    </p>
    <Image file={require('images/bindella_2.jpg')} source='Im historischen Kornhauskeller bewirtet Bindella bis zu 340 Personen. Bild: PD' proportions='16:9' mdxType="Image" />
    <p>
  Letztes Jahr übernahm die vierte Generation: Rudi Bindella junior übernahm von
  Vater Rudi Bindella, der das Unternehmen gross gemacht hat. Sein Sohn ist 42
  Jahre alt und gleist neue Konzepte auf. Das jüngste Projekt sind die
  Più-Ristoranti, die eine neapolitanisch-kosmopolitische Richtung einschlagen.
  Auch in der Bundesstadt: Das Kornhauscafé ist derzeit eingerüstet und wird zu
  einem Più umgebaut. Eröffnet soll es noch dieses Jahr werden. Bei der
  Bekanntgabe gab es einen Aufschrei: Berner monierten, dass es nicht noch mehr
  Pizzerias brauche, und politische Vorstösse fordern ein Literaturhaus. Der
  Pachtvertrag der Bindellas läuft bis 2030 weiter. Die Firma verzeichnet
  schweizweit einen Umsatz von 150 Millionen Franken, regionale Umsätze
  kommuniziert das Unternehmen nicht. Schweizweit sind 1300 Personen für
  Bindella tätig, in Bern sind es 197.
    </p>
    <ScrollTracking label='content25' mdxType="ScrollTracking" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;